import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CloseButtonModule } from '../../close-button/close-button.module';
import { ProceduresAwarenessOverlayComponent } from './procedures-awareness-overlay.component';
import { DlsIconModule } from '@zelis/dls/icons';

@NgModule({
  declarations: [ProceduresAwarenessOverlayComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FlexLayoutModule,
    FormsModule,
    CloseButtonModule,
    DlsIconModule,
  ],
  providers: [],
  exports: [ProceduresAwarenessOverlayComponent],
})
export class ProceduresAwarenessOverlayModule {}
